import { formatThousands, formatDecimal } from "@/utils/number";

/**
 * Format balance with thousands separator
 */
export const formatBalance = (balance: number): string => {
  return formatThousands(formatDecimal(balance) || 0, 4);
};

/**
 * Format balance with unit
 */
export const formatBalanceWithUnit = (
  balance: number,
  unit: string
): string => {
  return `${unit}${formatBalance(balance)}`;
};

/**
 * Get decimals based on whether it's TAO or not
 */
export const getTokenDecimals = (isTao: boolean): number => {
  return isTao ? 18 : 9;
};

/**
 * Check if netuid represents TAO
 */
export const isTaoToken = (netuid: number): boolean => {
  return netuid === -1;
};
